var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-2"},[_c('b-spinner',{staticClass:"align-middle mr-2",attrs:{"small":_vm.small}}),_c('strong',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }